var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3318 25H31.6651V28.3333H28.3318V25ZM28.3318 18.3333H31.6651V21.6666H28.3318V18.3333ZM28.3318 11.6666H31.6651V15H28.3318V11.6666ZM22.8984 11.6666L24.9984 13.0666V11.6666H22.8984Z",
    fill: "#5a5a5aff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 5V7.51667L20.0013 9.73333V8.33333H35.0013V31.6667H28.3346V35H38.3346V5H16.668Z",
    fill: "#5a5a5aff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.618 9.5L25.0013 17.0833V35H1.66797V17.4667L13.618 9.5ZM16.668 31.6667H21.668V18.6L13.618 13.4833L5.0013 18.9667V31.6667H10.0013V21.6667H16.668V31.6667Z",
    fill: "#5a5a5aff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHome);
export default __webpack_public_path__ + "static/media/activeHome.b74adfbabb2c3933be0dc587442a2179.svg";
export { ForwardRef as ReactComponent };